import React from "react";
import { Human, Lamp } from "../assets/svg/icons";
import useResponsive from "../hooks/useResponsive";

const Herospace = () => {
  const { Default } = useResponsive();
  return (
    <div className="header_herospace">
      <Human />
      <div className="herospace">
        <h1 className="herospace_title">Vem bestämmer</h1>
        <Default>
          <p className="herospace_text">
            Ett roligt spel som lär dig vem som bestämmer vad
          </p>
        </Default>
      </div>
      <Lamp />
    </div>
  );
};

export default Herospace;
